module.exports = __webpack_public_path__ + "img/girl_modern.9b472a8c.png";